import type { GeneratorOptions, Schema } from '@cli-types/core-engine/schema.js'
import type { EditPageGeneratorResult } from '@cli-types/next-adapter/generators.js'
import { createGeneratedFile } from '@cli-utils/files.js'
import { singularize, toCamelCase, toKebabCase, toPascalCase } from '@cli-utils/text.js'
import { resolveDisplayNouns } from '@core-engine/schema/display-nouns.js'
import { resolveSchemaActionImportPath } from '@next-adapter/config/paths/resolve-schema-action-import-path.js'
import { buildLoadingSkeletonSource } from '@next-adapter/generators/emitted-helpers.js'
import { renderEditPageContentTemplate } from '@next-adapter/templates/renderers/generators/edit-page-content.js'
import { renderEditPageTemplate } from '@next-adapter/templates/renderers/generators/edit-page.js'

export function generateEditPage(
  schema: Schema,
  pagesDir: string,
  options: GeneratorOptions = {}
): EditPageGeneratorResult {
  const singular = singularize(schema.name)
  const Singular = toPascalCase(singular)
  const camelSingular = toCamelCase(singular)
  const kebabName = toKebabCase(schema.name)
  const kebabSingular = toKebabCase(singular)
  const actionImportPath = resolveSchemaActionImportPath(schema.name, options.outputNamespace)
  const displayNouns = resolveDisplayNouns(schema)

  const page = renderEditPageTemplate({ singular: Singular, kebabSingular: kebabSingular })
  const content = renderEditPageContentTemplate({
    singular: Singular,
    actionImportPath: actionImportPath,
    kebabName: kebabName,
    camelSingular: camelSingular
  })
  const skeleton = buildLoadingSkeletonSource(`Edit${Singular}PageSkeleton`, displayNouns.singular)

  const editDir = `${pagesDir}/${schema.name}/[id]/edit`

  return {
    files: [
      createGeneratedFile(`${editDir}/page.tsx`, page),
      createGeneratedFile(`${editDir}/edit-${kebabSingular}-page-content.tsx`, content),
      createGeneratedFile(`${editDir}/edit-${kebabSingular}-page-skeleton.tsx`, skeleton)
    ]
  }
}
